const getters = {};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/research/getters.js